import { Heading1 } from 'components/shared/Typography';
import styled from 'styled-components';
import {
  color,
  container,
  fontSize,
  radius,
  screen,
  shadow,
  spacing
} from 'theme';
import { getPublicPath } from 'utils/paths';

export const StyledHero = styled.div`
  background-image: ${() =>
    `url('${getPublicPath('/images/salaryCompass/bg-hero.svg')}')`};
  background-repeat: no-repeat;
  background-position: left 15% bottom;
  background-size: cover;
  padding: 0 ${spacing('md')};
  margin-bottom: ${spacing('xl')};

  @media (min-width: ${screen('lg')}) {
    padding: ${spacing('xl4')} ${spacing('xl')} ${spacing('md')};
    background-size: cover;
    background-position: center bottom;
    margin-bottom: ${spacing('xl4')};
  }
`;

export const StyledHeroContainer = styled.div`
  max-width: ${container('xl')};
  margin: auto;
  padding-top: ${spacing('xl2')};
  padding-bottom: ${spacing('xl4')};
  display: flex;
  flex-direction: column;
  gap: ${spacing('xl')};
  z-index: 1;
  position: relative;

  @media (min-width: ${screen('lg')}) {
    flex-direction: row;
  }
`;

export const StyledHeroText = styled.div`
  max-width: ${container('xs')};
  color: ${color('text_white')};
  line-height: 1.5;
  text-align: center;
  margin: auto;

  @media (min-width: ${screen('lg')}) {
    text-align: left;
    font-size: ${fontSize('lg')};
    line-height: 1.4;
    margin: unset;
    margin-bottom: ${spacing('xl3')};
  }
`;

export const StyledHeroTitle = styled(Heading1)`
  margin-bottom: ${spacing('lg')};
`;

export const StyledHeroImage = styled.div`
  text-align: center;

  img {
    display: block;
    border-top-left-radius: ${radius('md')};
    border-top-right-radius: ${radius('md')};
    border-bottom-left-radius: ${radius('lg')};
    border-bottom-right-radius: ${radius('lg')};
    box-shadow: ${shadow('lg')};
  }
`;
